import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h5 font-weight-bold" }, "Offres Flash", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-h5 font-weight-bold" }, "Ton Prochain Événement", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-h5 font-weight-bold" }, "Partenaire du Jour", -1)

import { computed, inject, ref } from "vue";
import type { ComputedRef } from "vue";
import PartnerCard from "../components/PartnerCard.vue";
import EventCard from "../components/EventCard.vue";

import { Partner, Event } from "@emblem/api";

// const cityLogo = inject<ComputedRef<string>>("city:logo");


import { defineComponent } from "vue";
import CarouselBackground from "@/components/CarouselBackground.vue";
import router from "@/router";
const __default__ = defineComponent({
  name: "HomePage",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const search = ref("");
function onSearch() {
  router.push({ path: "/offers", query: { search: search.value } });
}

const partners = inject("partners:list") as ComputedRef<Partner[]>;
const partnersWithFlashOffer = computed(() =>
  partners.value.filter((p) => p.offers.filter((o) => o.flash).length)
);

const today = new Date();
const firstDayInYear = new Date(today.getFullYear(), 0, 0);
const todayIndex = Math.floor(
  (today.getTime() - firstDayInYear.getTime()) / (24 * 60 * 60 * 1000)
);
const todaysPartner = computed(
  () => partners.value[todayIndex % partners.value.length]
);

const nextEvent = computed(() => {
  const events = (inject("events:list") as ComputedRef<Event[]>).value;
  const now = Date.now();
  let nextEvent;
  for (const event of events) {
    if (event.end.getTime() >= now) {
      nextEvent = event;
    } else {
      break;
    }
  }
  return nextEvent;
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    id: "home-container",
    class: "fill-height"
  }, {
    default: _withCtx(() => [
      _createVNode(CarouselBackground),
      _createVNode(_component_v_row, { style: {"position":"relative"} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: search.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                class: "rounded-search light",
                "prepend-inner-icon": "fas fa-magnifying-glass",
                "hide-details": "",
                density: "compact",
                placeholder: "Recherche",
                "append-inner-icon": "fas fa-times",
                "onClick:appendInner": _cache[1] || (_cache[1] = ($event: any) => (search.value = '')),
                onKeyup: _withKeys(onSearch, ["enter"])
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _: 1
          }),
          (_unref(partnersWithFlashOffer).length)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _hoisted_1,
                          _createVNode(_component_v_divider, { class: "mb-2" }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(partnersWithFlashOffer), (partner, i) => {
                            return (_openBlock(), _createBlock(PartnerCard, {
                              key: i,
                              partner: partner,
                              "offer-filter": (o) => o.flash,
                              class: "mb-2"
                            }, null, 8, ["partner", "offer-filter"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(nextEvent))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _hoisted_2,
                          _createVNode(_component_v_divider, { class: "mb-2" }),
                          _createVNode(EventCard, { event: _unref(nextEvent) }, null, 8, ["event"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(todaysPartner))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _hoisted_3,
                          _createVNode(_component_v_divider, { class: "mb-2" }),
                          _createVNode(PartnerCard, { partner: _unref(todaysPartner) }, null, 8, ["partner"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})